// Privacy banner persistence fallback — remembers dismissal across pages
(function() {
  var KEY = 'privacy-banner-dismissed';
  var CLASS = 'privacy-dismissed';

  function setFlagAndHide() {
    try { localStorage.setItem(KEY, '1'); } catch(e) {}
    document.documentElement.classList.add(CLASS);
    document.querySelectorAll('privacy-banner').forEach(function(b){
      try { b.remove(); } catch(e){ b.style.display = 'none'; }
    });
  }

  // Initial: if flag set, remove banner element entirely (CSS already hides via html class)
  function checkAndRemove() {
    try {
      if (localStorage.getItem(KEY) === '1') {
        document.documentElement.classList.add(CLASS);
        document.querySelectorAll('privacy-banner').forEach(function(b){ try{b.remove();}catch(e){} });
      }
    } catch(e) {}
  }
  checkAndRemove();
  document.addEventListener('DOMContentLoaded', checkAndRemove);

  // Watch for any later-added banner instance (Shopify may inject async)
  new MutationObserver(checkAndRemove).observe(document.documentElement, {childList:true, subtree:true});

  // Listen for accept/decline/close clicks anywhere — capture phase to fire first
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('privacy-banner [data-action], privacy-banner .pop-in__close-button, .privacy-banner [data-action]');
    if (btn) setFlagAndHide();
  }, true);
})();
